module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.3-vote-procedure.0e0953b3.png";